import React, { useMemo } from 'react';

import { Modal } from 'antd';
import Slider from 'react-slick';

import { setGlobalCarouselMediaList } from '../../../../context/communityReducer';
import {
  useAppDispatch,
  useAppNavigate,
  useAppSelector,
} from '../../../../shared/hooks';
import CreatePostMediaRender from '../../../CreateCommunityPost/components/CreatePostMediaRender/CreatePostMediaRender';

type Props = {};

const CommunityGlobalCarousel: React.FC<Props> = () => {
  const navigate = useAppNavigate();
  const search = new URLSearchParams(window?.location?.search);
  const initialSlideParams = search.get('initialSlide');

  const dispatch = useAppDispatch();
  const { globalCarouselMediaList } = useAppSelector(
    (state) => state.community,
  );

  const initialSlide = useMemo(() => {
    if (initialSlideParams && Number.parseInt(initialSlideParams)) {
      return Number.parseInt(initialSlideParams);
    }
    return 0;
  }, [initialSlideParams]);

  return (
    <Modal
      open={globalCarouselMediaList?.length > 0}
      title={null}
      destroyOnClose
      className="full-page-model globalMediaCarouselModal"
      closable
      footer={null}
      onCancel={() => {
        navigate.goBack();
        dispatch(setGlobalCarouselMediaList([]));
      }}
      closeIcon={null}>
      <Slider
        className="globalMediaCarousel"
        easing="linear"
        arrows
        swipeToSlide
        dots={false}
        slidesToShow={1}
        initialSlide={initialSlide || 0}
        infinite={false}>
        {globalCarouselMediaList.map((media) => (
          <div>
            {
              <CreatePostMediaRender
                files={[media]}
                postedBy={media?.postedBy}
              />
            }
          </div>
        ))}
      </Slider>
    </Modal>
  );
};

export default CommunityGlobalCarousel;
